<template>
	<Popup
		v-model="selfDisplay"
		title="修改带训人"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
				<el-input v-model="name" placeholder="姓名"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="name_tip"><i class="b_icon"></i>请输入姓名</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
				<el-input :value="mobile" placeholder="手机号" disabled></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="mobile_tip"><i class="b_icon"></i>请输入账号</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>性别</span>
				<el-select v-model="sex" style="width: 100%;">
					<el-option :value="0" label="男"></el-option>
					<el-option :value="1" label="女"></el-option>
				</el-select>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>出生年月</span>
				<el-date-picker
					v-model="birth"
					:editable="false"
					placeholder="出生年月"
					type="date"
					value-format="yyyy-MM-dd"
					@change="handleDateChange"
				>
				</el-date-picker>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="birth_tip"><i class="b_icon"></i>请选择出生年月</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>所属机构</span>
				<el-autocomplete
					v-model="firmName"
					value-key="name"
					:fetch-suggestions="queryFirmName"
					placeholder="请输入机构名称"
					@select="handleFirmSelect"
				></el-autocomplete>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="firm_tip"><i class="b_icon"></i>请选择机构名称</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted() {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return {
				selfDisplay: false,
				loading: false,
				
				id: '',
				name: '',
				mobile: '',
				sex: 0,
				birth: '',
				firmId: '',
				firmName: '',
				firms: [],
				name_tip: false,
				mobile_tip: false,
				birth_tip: false,
				firm_tip: false
			}
		},
		computed: {
			...mapState(['authInfo'])
		},
		methods: {
			/************************** @Events ***************************/
			// 选择训练时间
			handleDateChange() {
				if (this.birth) {
					var destTime = new Date(this.birth).getTime(),
						nowTime = new Date().getTime();
					if (destTime > nowTime) {
						this.$message.warning('出生日期不能超过当天！！！');
						this.birth = '';
					}
				}
			},
			// 选择机构
			handleFirmSelect(firm) {
				this.firmId = firm.id;
				this.firmName = firm.name;
			},
			// 点击新增
			handleConfirmClick() {
				const that = this;
				if (!that.name.trim()) {
					that.name_tip = true;
					return false;
				} else {
					that.name_tip = false;
				}
				if (!that.mobile.trim()) {
					that.mobile_tip = true;
					return false;
				} else {
					that.mobile_tip = false;
				}
				if (!that.birth) {
					that.birth_tip = true;
					return false;
				} else {
					that.birth_tip = false;
				}
				if (!that.firmId) {
					that.firm_tip = true;
					return false;
				} else {
					that.firm_tip = false;
				}
				that.loading = true;
				let requestData = {
					age: null,
					birth: that.birth,
					code: that.mobile,
					createTime: null,
					createrId: that.authInfo.uid,
					dr: null,
					eglTrainerName: that.name,
					graduateSchool: that.school,
					id: that.id,
					sex: that.sex,
					uenterpriseId: that.firmId,
					uenterpriseName: that.firmName,
					updateTime: null
				};
				Api.updateTrainer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$emit('success');
						that.$message.success(res.data.message);
						that.selfDisplay = false;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/************************** @Function ***************************/
			// 所属机构匹配
			queryFirmName(queryString, cb) {
				const that = this;
				that.queryInterval && clearTimeout(that.queryInterval);
				that.queryInterval = setTimeout(() => {
					var results = [];
					var requestData = {
						EnterpriseName: queryString
					};
					Api.queryFirmsByName(requestData).then((res) => {
						if (res.data.success) {
							res.data.data.forEach(v => {
								results.push({
									name: v.name,
									id: v.uid
								});
							});
							cb(results);
						} else {
							cb([]);
						}
					}, () => {
						cb([]);
					});
				}, 300);
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false,
					
					this.id = '';
					this.name = '';
					this.mobile = '';
					this.sex = 0;
					this.birth = '';
					this.firmId = '';
					this.firmName = '';
					this.firms = [];
					this.name_tip = false;
					this.mobile_tip = false;
					this.birth_tip = false;
					this.firm_tip = false;
					
					this.queryInterval && clearTimeout(this.queryInterval);
				} else {
					this.id = this.obj.id;
					this.name = this.obj.name;
					this.mobile = this.obj.mobile;
					this.sex = this.obj.sex;
					this.birth = this.obj.birth;
					this.firmId = this.obj.firmId;
					this.firmName = this.obj.firmName;
					this.firms = [];
				}
			},
			firmName(newValue) {
				if (this.firmName != newValue) {
					this.firmId = '';
					this.firmName = '';
				}
			}
		}
	}
</script>

<style>
</style>
